import { datajs, datajsAll } from '../shared/utils';

export default class ReadMore {
	static init() {
		const readMoreWrappers = datajsAll('read-more-wrapper');
		let trigger, content;

		if (readMoreWrappers.length === 0) {
			return false;
		}

		readMoreWrappers.forEach((wrapper) => {
			trigger = datajs('read-more-trigger', wrapper);
			content = datajs('read-more-content', wrapper);

			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				content.classList.add('is-expanded');
				trigger.classList.add('d-none');
			});
		});
	}
}
